import React from 'react';
import useBlogSearchParams from '../use-blog-search-params';
import SortToggle from '~/components/sort-toggle/sort-toggle';
import './facet-controls.scss';
function SubjectChips({ subjects }) {
    const { subjects: active, setParam } = useBlogSearchParams();
    const toggle = (name) => {
        const next = active.includes(name)
            ? active.filter((s) => s !== name)
            : [...active, name];
        setParam('subjects', next);
    };
    return (React.createElement("div", { className: "facet-group", role: "group", "aria-label": "Filter by subject" }, subjects.map((s) => (React.createElement("button", { key: s.name, type: "button", className: "facet-chip", "aria-pressed": active.includes(s.name), onClick: () => toggle(s.name) }, s.name)))));
}
function CollectionSelect({ collections }) {
    const { collection, setParam } = useBlogSearchParams();
    return (React.createElement("label", { className: "facet-select", htmlFor: "blog-collection-select" },
        React.createElement("span", { className: "facet-label" }, "Collection"),
        React.createElement("select", { id: "blog-collection-select", value: collection !== null && collection !== void 0 ? collection : '', onChange: (e) => setParam('collection', e.currentTarget.value) },
            React.createElement("option", { value: "" }, "All collections"),
            collections.map((c) => (React.createElement("option", { key: c.name, value: c.name }, c.name))))));
}
export default function FacetControls({ subjects, collections }) {
    const { sort, setParam } = useBlogSearchParams();
    return (React.createElement("div", { className: "facet-controls", role: "group", "aria-label": "Filter and sort blog posts" },
        React.createElement(SubjectChips, { subjects: subjects }),
        React.createElement("div", { className: "facet-row" },
            React.createElement(CollectionSelect, { collections: collections }),
            React.createElement(SortToggle, { sort: sort, setSort: (value) => setParam('sort', value), labelId: "blog-sort-label", className: "facet-sort-position" }))));
}
